// @dynamic-i18n-keys
// Dynamic t() at line 31 (isMobile suffix):
//   studio.blankSlate.scheduled.message
//   studio.blankSlate.scheduled.message.mobile
import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BuyCoreBrandedButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreBrandedButton';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { illustrationUrl } from '../../StudioBlankSlate';
import BasicBlankSlate from '../../_partials/BasicBlankSlate';

const SCHEDULED_IMG_URL = illustrationUrl('studio-scheduled-empty.png', 2);

const ScheduledBlankSlate: FC<{}> = () => {
  const { t } = useTranslation();
  const { hasCoreMembership } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);

  const draftsTabLink = (
    <PlainButtonOrLink className="text-link-level-1-brand" href={Url.studio()}>
      {t('studio.blankSlate.scheduled.draftsTabLinkText')}
    </PlainButtonOrLink>
  );

  return (
    <BasicBlankSlate
      illustrationSrc={SCHEDULED_IMG_URL}
      title={t('studio.blankSlate.scheduled.title')}
      message={t(
        `studio.blankSlate.scheduled.message${isMobile ? '.mobile' : ''}`,
        {
          postProcess: ['reactPostprocessor', 'featureBrancher'],
          draftsTabLink,
        }
      )}
      cta={
        hasCoreMembership ? (
          false
        ) : (
          <BuyCoreBrandedButton
            size="large"
            biData={BiData<BuyCoreButtonBiEvent>({
              evid: 375,
              referral_info: ReferralType.STUDIO_SCHEDULED_TAB,
            })}
          >
            {t('studio.blankSlate.scheduled.cta.nonCore')}
          </BuyCoreBrandedButton>
        )
      }
    />
  );
};
ScheduledBlankSlate.displayName = 'ScheduledBlankSlate';

export default ScheduledBlankSlate;
